import React from "react";
import { RangeSlider } from "component-library";

import "./BrightnessSetting.scss";

export interface IBrightnessState {
  brightness: number;
}

export interface IBrightnessSettingProps {
  minValue: number;
  maxValue: number;
  step: number;
  value: number;
  texts: {
    minValueName: string;
    maxValueName: string;
  };
  changeValue: (value: IBrightnessState) => void;
  disabled: boolean;
}

interface IBrightnessSettingState {
  value: number;
}

export class BrightnessSetting extends React.Component<
  IBrightnessSettingProps,
  IBrightnessSettingState
> {
  constructor(props: IBrightnessSettingProps) {
    super(props);

    this.state = {
      value: props.value,
    };
  }

  public render() {
    return (
      <div className="c-brightness-setting">
        <RangeSlider
          disabled={this.props.disabled}
          texts={this.props.texts}
          value={this.props.value}
          step={this.props.step}
          maxValue={this.props.maxValue}
          minValue={this.props.minValue}
          onChange={this.changeValue}
        />
      </div>
    );
  }

  public componentWillReceiveProps(nextProps: IBrightnessSettingProps) {
    this.setState({ value: nextProps.value });
  }

  public changeValue = (event: React.ChangeEvent<HTMLInputElement> | any) => {
    this.props.changeValue({ brightness: parseFloat(event.target.value) });
  };
}
